var $ = global.jQuery = global.$;
var _Base = require('./_Base');
var widgets = require('../lib/widgets');
var dot = require('dot');


var MultiOverlay = require('./MultiOverlay');

/**
 * Mobile navigation widget
 * @class
 * @extends _Base
 */
var MultiOverlayItem = _Base.extend(
  /** @lends MultiOverlayItem.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.itemDataUrl = this.$el.data('url');
    this.overlay = widgets.getById('MultiItemOverlay');
    this.templateRaw = $(this.$el.data('template')).text().trim();
    this.template = dot.template(this.templateRaw);

    this.$el.attr('tabindex', 0);

    if (!this.overlay) {
      var div = $('<div class="overlay" id="MultiItemOverlay"/>'),
        overlay;
      $('body').append(div);
      this.overlay = widgets.addToRegistry(div, MultiOverlay);
    }
    this.index = this.overlay.addItem(this);

    this.$el.on('click', function(event) {
      event.preventDefault();

      self.overlay.open(self.index);
    });
  },
  getItemData: function(callback) {
    var self = this;
    return $.ajax({
      type: 'GET',
      contentType: 'application/json',
      url: this.itemDataUrl
    })
    .done(function(response) {
      self.data = response.Value;
      self.renderedHtml = self.template(self.data);
      if (typeof callback === 'function') callback();
    })
    .fail(function() {

    });
  }
});

module.exports = MultiOverlayItem;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/MultiOverlayItem.js
// module id = 304
// module chunks = 0